import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import FloatingButtons from "./components/feature/FloatingButtons";
import SeoManager from "./components/SeoManager";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <SeoManager />
        <AppRoutes />
        <ScrollToTop />
        <FloatingButtons />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
